import virtualiedRenderer from './virtualizedRenderer'
export default virtualiedRenderer
